import React, { Component } from 'react'
import i18next from 'i18next'
import { Link } from 'react-router'
import { Row, Col, FormGroup } from 'react-bootstrap'
import { Map } from 'immutable'
import queryString from 'query-string'
import classnames from 'classnames'

import GridContainer from './GridContainer'
import Paginator from './Paginator'
import Loading from './Loading'
import UnitNoResults from './UnitNoResults'
import UnitListRow from './UnitListRow'
import BottomBarListSelection from './BottomBarListSelection'
import LanguageSelectorFormControl from './LanguageSelectorFormControl'

import buttonStyles from './styles/button.scss'
import listingStyles from './styles/listing.scss'
import unitStyles from './styles/unit.scss'

const makeDownloadUrl = (selectedUnits, language) => {
  const params = {
    uuid: selectedUnits
      .map(unit => unit.uuid)
      .keySeq()
      .toJS()
  }

  return `/api/units/targets/profiles/${language}?${queryString.stringify(params)}`
}

export default class UnitList extends Component {
  state = {
    selectedUnits: Map(),
    language: this.props.currentLanguage
  }

  componentDidMount() {
    this.props.getUnits(this.props.currentOrganisationId, 1)
  }

  handleSelectUnit = uuid => {
    if (this.state.selectedUnits.has(uuid)) {
      this.setState({ selectedUnits: this.state.selectedUnits.delete(uuid) })
    } else {
      this.setState({ selectedUnits: this.state.selectedUnits.set(uuid, true) })
    }
  }

  handleDelete = uuid => {
    if (confirm(i18next.t('are_you_sure'))) {
      this.props.deleteUnit(this.props.currentOrganisationId, uuid)
    }
  }

  handlePagination = page => {
    this.props.getUnits(this.props.currentOrganisationId, page)
  }

  clearSelections = () => {
    this.setState({ selectedUnits: Map() })
  }

  handleLanguageChange = e => {
    this.setState({ language: e.target.value })
  }

  render() {
    const { selectedUnits, language } = this.state
    const { units, deletedUnits, pagination, isLoading } = this.props

    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <Row>
            <Col md={12}>
              <header>
                <h1>{i18next.t('units')}</h1>

                <Link to="/units/new" className={buttonStyles.button} style={{ marginLeft: 20 }}>
                  {i18next.t('unit_create_new')}
                </Link>
              </header>
            </Col>
          </Row>

          <Loading inline={true} isReady={!isLoading}>
            {units && (
              <div style={{ marginTop: '15px' }}>
                {units.isEmpty() && <UnitNoResults />}

                {!units.isEmpty() && (
                  <div className="table-responsive">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th style={{ textAlign: 'center', width: 80 }}>{i18next.t('select')}</th>
                          <th style={{ width: 600 }}>{i18next.t('unit_name')}</th>
                          <th>{i18next.t('unit_wopi360_profiles')}</th>
                          <th>{i18next.t('delete')}</th>
                        </tr>
                      </thead>

                      <tbody>
                        {units.map(unit => (
                          <UnitListRow
                            key={unit.uuid}
                            unit={unit}
                            isSelected={selectedUnits.has(unit.uuid)}
                            isDeleted={deletedUnits.contains(unit.uuid)}
                            onSelect={this.handleSelectUnit}
                            onDelete={this.handleDelete}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {pagination && (
                  <Paginator
                    totalCount={pagination.totalCount}
                    page={pagination.page}
                    limit={pagination.limit}
                    onPaginate={this.handlePagination}
                  />
                )}
              </div>
            )}
          </Loading>

          <BottomBarListSelection
            isVisible={!selectedUnits.isEmpty()}
            selectedCount={selectedUnits.size}
            onDeselect={this.clearSelections}
          >
            <div className={unitStyles.unitBottomBarActions}>
              <a className={buttonStyles.button} href={makeDownloadUrl(selectedUnits, language)}>
                {i18next.t('download')}
              </a>

              <FormGroup
                className={classnames('form-inline', listingStyles.profileExtrasForm)}
                style={{ marginLeft: '20px' }}
              >
                <LanguageSelectorFormControl
                  onChange={this.handleLanguageChange}
                  defaultValue={language}
                  showOnlyAdminLanguages={false}
                  shouldTranslateLanguages={true}
                  withoutFormGroup
                />
              </FormGroup>
            </div>
          </BottomBarListSelection>
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitList.js